module.exports = __webpack_public_path__ + "static/img/chart-pic11.d02d2b08.png";